import Vue from "vue";
import App from "@/portal/app";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "./plugins";
import "./extend";
import "@/utils/validator";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
